module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"jquery","commonjs":"jquery","commonjs2":"jquery","root":"jQuery"}
// module id = 0
// module chunks = 0